import { render } from "./SearchTitle.vue?vue&type=template&id=dda7b464"
import script from "./SearchTitle.vue?vue&type=script&lang=js"
export * from "./SearchTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__